var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticClass:"shows-route-episodes-route-container",attrs:{"keep-alive":"","transition":"app","transition-mode":"out-in"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }